// extracted by mini-css-extract-plugin
export default {"emptyLearn":"EmptyLearn_emptyLearn__ye945"};